

export type LuceneIndexInputType = "Standard" | "Buffered";
